import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import tradesSubscriptionService from '../../services/subscriptions/tradesSubscriptionService';
export var REQUEST_RECENT_TRADES = 'REQUEST_RECENT_TRADES';
export var RECEIVE_RECENT_TRADES = 'RECEIVE_RECENT_TRADES';
export var ADD_RECENT_TRADE = 'ADD_RECENT_TRADE';
export var RECEIVE_RECENT_TRADES_ERROR = 'RECEIVE_RECENT_TRADES_ERROR';

/**
 * 1) Tell server to subscribe to trades data for passed `instrumentId`
 * 2) Get first portion of data
 */
export var getRecentTrades = function getRecentTrades(instrumentId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestRecentTrades());
              _context.next = 3;
              return tradesSubscriptionService.initSubscribtion(instrumentId).then(function (res) {
                return dispatch(receiveRecentTrades(instrumentId, res));
              }).catch(function (e) {
                console.error(e);
              });
            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var subscribeToRecentTrades = function subscribeToRecentTrades() {
  return function (dispatch, getState) {
    var instrumentId = getState().apexCore.instrument.selectedInstrumentId;
    tradesSubscriptionService.subscribe(function (updates) {
      dispatch(addRecentTrade(instrumentId, updates));
    }, instrumentId);
  };
};
export var unsubscribeRecentTrades = function unsubscribeRecentTrades(instrumentId) {
  return function (dispatch) {
    tradesSubscriptionService.stopOne(instrumentId);
  };
};
export var unsubscribeAllRecentTrades = function unsubscribeAllRecentTrades() {
  return function (dispatch) {
    tradesSubscriptionService.stopAll();
  };
};
export var receiveRecentTrades = function receiveRecentTrades(instrumentId, data) {
  return {
    type: RECEIVE_RECENT_TRADES,
    payload: {
      instrumentId: instrumentId,
      data: data
    }
  };
};
export var receiveRecentTradesError = function receiveRecentTradesError(instrumentId, error) {
  return {
    type: RECEIVE_RECENT_TRADES_ERROR,
    payload: {
      instrumentId: instrumentId,
      error: error
    }
  };
};
export var requestRecentTrades = function requestRecentTrades() {
  return {
    type: REQUEST_RECENT_TRADES
  };
};
export var addRecentTrade = function addRecentTrade(instrumentId, data) {
  return {
    type: ADD_RECENT_TRADE,
    payload: {
      instrumentId: instrumentId,
      data: data
    }
  };
};